/**
 * Brand mark — official Diet of Happiness logo.
 * Two artwork files: black on transparent (for light surfaces) and the
 * colour-inverted white version (for dark surfaces).
 */
import { cn } from "@/lib/utils";
const logoDark = { url: "/images/happy-diet-logo.png" };
const logoLight = { url: "/images/happy-diet-logo-light.png" };

interface BrandMarkProps {
  className?: string;
  /** Color scheme: 'dark' for cream backgrounds, 'light' for dark backgrounds */
  variant?: "dark" | "light";
  /** Optional size override (tailwind height class). Defaults to responsive 2.4 / 2.7rem */
  sizeClassName?: string;
}

const BrandMark = ({ className, variant = "dark", sizeClassName }: BrandMarkProps) => {
  const heightClass = sizeClassName ?? "h-[2.4rem] md:h-[2.7rem]";

  return (
    <span className={cn("inline-flex items-center", className)}>
      <img
        src={variant === "light" ? logoLight.url : logoDark.url}
        alt="Diet of Happiness"
        className={cn(heightClass, "w-auto select-none")}
        draggable={false}
      />
    </span>
  );
};

export default BrandMark;

